import React, { useState, useEffect } from 'react'
import { useSearchParams, useLocation, useNavigate, createSearchParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Typography, Button } from '@mui/material'
import { useGlobalStore } from '../../store'
import { MuiButton } from '../../components'
import {
  NAME_SOCIAL_MONITOR, NAME_VERBATIM_MANAGEMENT, NAME_KEYWORD_MANAGEMENT, NAME_NEW_AGGREGATION, NAME_QUESTION_MANAGEMENT, NAME_SUB_QUESTION_MANAGEMENT, NAME_USER_MANAGEMENT, NAME_ADMIN_TOOL,
  ROUTE_SOCIAL_MONITOR, ROUTE_VERBATIM_MANAGEMENT, ROUTE_KEYWORD_MANAGEMENT, ROUTE_NEW_AGGREGATION, ROUTE_QUESTION_MANAGEMENT, ROUTE_SUB_QUESTION_MANAGEMENT,
  CONST_QUESTION_MANAGEMENT_DETAILS, CONST_SUB_QUESTION_MANAGEMENT_DETAILS, ROUTE_USER_MANAGEMENT, ROUTE_ADMIN_TOOL
} from '../../constants'
import { ArrowDownIos } from '../../assets/img/icons'
import { HeadingWrapper, MenuWrapper } from './style'

const BreadCrumb = ({ pageTitle = '' }) => {
  const { company } = useGlobalStore()
  const [searchParams] = useSearchParams()
  const [questionPageObject, setQuestionPageObject] = useState(null)
  const [anchorEl_1, setAnchorEl_1] = useState(null)
  const [anchorEl_2, setAnchorEl_2] = useState(null)
  const open1 = Boolean(anchorEl_1)
  const open2 = Boolean(anchorEl_2)
  const handleClick = (event, id) => { id === 1 ? setAnchorEl_1(event.currentTarget) : setAnchorEl_2(event.currentTarget) }
  const handleClose = () => { setAnchorEl_1(null); setAnchorEl_2(null) }
  const location = useLocation().pathname
  const navigate = useNavigate()

  const linkClickedFunc = (object, path) => {
    navigate({
      pathname: path,
      search: createSearchParams({ type: object.type }).toString()
    })
    handleClose()
    setQuestionPageObject(object)
  }

  useEffect(() => {
    if (ROUTE_QUESTION_MANAGEMENT === location) {
      const page = CONST_QUESTION_MANAGEMENT_DETAILS.filter(f => f.type === searchParams.get('type'))
      const pageObject = page.length > 0 ? page[0] : CONST_QUESTION_MANAGEMENT_DETAILS[0]
      setQuestionPageObject(pageObject)
    } else if (ROUTE_SUB_QUESTION_MANAGEMENT === location) {
      const page = CONST_SUB_QUESTION_MANAGEMENT_DETAILS.filter(f => f.type === searchParams.get('type'))
      const pageObject = page.length > 0 ? page[0] : CONST_SUB_QUESTION_MANAGEMENT_DETAILS[0]
      setQuestionPageObject(pageObject)
    }
  }, [])

  return (
    <HeadingWrapper>
      <Typography className='buttonWrapper'>
        <Button
          id='basic-button'
          aria-controls={open1 ? 'basic-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open1 ? 'true' : undefined}
          onClick={(e) => handleClick(e, 1)}
          className='menuButton'
        >
          {pageTitle} <ArrowDownIos />
        </Button>
        <MenuWrapper
          id='basic-menu'
          anchorEl={anchorEl_1}
          open={open1}
          onClose={handleClose}
          MenuListProps={{ 'aria-labelledby': 'basic-button' }}
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <MuiButton to={ROUTE_SOCIAL_MONITOR}>{NAME_SOCIAL_MONITOR}</MuiButton>
          <MuiButton to={ROUTE_VERBATIM_MANAGEMENT}>{NAME_VERBATIM_MANAGEMENT}</MuiButton>
          <MuiButton to={ROUTE_KEYWORD_MANAGEMENT}>{NAME_KEYWORD_MANAGEMENT}</MuiButton>
          <MuiButton to={ROUTE_QUESTION_MANAGEMENT}>{NAME_QUESTION_MANAGEMENT}</MuiButton>
          <MuiButton to={ROUTE_SUB_QUESTION_MANAGEMENT}>{NAME_SUB_QUESTION_MANAGEMENT}</MuiButton>
          <MuiButton to={ROUTE_NEW_AGGREGATION}>{NAME_NEW_AGGREGATION}</MuiButton>
          <MuiButton to={ROUTE_USER_MANAGEMENT}>{NAME_USER_MANAGEMENT}</MuiButton>
          <MuiButton to={ROUTE_ADMIN_TOOL}>{NAME_ADMIN_TOOL}</MuiButton>
        </MenuWrapper>

        {
          ROUTE_QUESTION_MANAGEMENT === location &&
          <>
            <Button
              id='question-button'
              aria-controls={open2 ? 'question-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={open2 ? 'true' : undefined}
              onClick={(e) => handleClick(e, 2)}
              className='menuButton'
              style={{ marginLeft: '15px' }}
            >
              {questionPageObject?.title} <ArrowDownIos />
            </Button>
            <MenuWrapper
              id='question-menu'
              anchorEl={anchorEl_2}
              open={open2}
              onClose={handleClose}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              {CONST_QUESTION_MANAGEMENT_DETAILS.map((d, i) => {
                return (
                  <MuiButton key={i} onClick={() => linkClickedFunc(d, ROUTE_QUESTION_MANAGEMENT)}>{d.title}</MuiButton>
                )
              })}
            </MenuWrapper>
          </>
        }
        {
          ROUTE_SUB_QUESTION_MANAGEMENT === location &&
          <>
            <Button
              id='question-button'
              aria-controls={open2 ? 'question-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={open2 ? 'true' : undefined}
              onClick={(e) => handleClick(e, 2)}
              className='menuButton'
              style={{ marginLeft: '15px' }}
            >
              {questionPageObject?.title} <ArrowDownIos />
            </Button>
            <MenuWrapper
              id='question-menu'
              anchorEl={anchorEl_2}
              open={open2}
              onClose={handleClose}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              {CONST_SUB_QUESTION_MANAGEMENT_DETAILS.map((d, i) => {
                return (
                  <MuiButton key={i} onClick={() => linkClickedFunc(d, ROUTE_SUB_QUESTION_MANAGEMENT)}>{d.title}</MuiButton>
                )
              })}
            </MenuWrapper>
          </>
        }
      </Typography>
      <Typography>{(company?.WebName || company?.DisplayName)}</Typography>

      {/* <Typography>{pageTitle} {pageTitle === '' && (company?.WebName || company?.DisplayName)}</Typography> */}
      {/* <Typography>{pageTitle !== '' && (company?.WebName || company?.DisplayName)}</Typography> */}
    </HeadingWrapper>
  )
}

BreadCrumb.propTypes = {
  pageTitle: PropTypes.string
}

BreadCrumb.displayName = 'BreadCrumb'

export default BreadCrumb
